module.exports = __webpack_public_path__ + "static/media/MK 16-17.e1152319.mp3";